import React from 'react';
import { Card, Button, Tag, Divider } from 'antd';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCalendarAlt, faClock, faBell } from "@fortawesome/free-solid-svg-icons";
import { formatDateTime, formatDateTimeFromNow } from '../../../../utils/functions';
import SOURCES from '../../../../utils/constants';

const EnhancedNotificationDetails = ({
    notification,
    onMarkAsRead
}) => {
    if (!notification) return null;

    const isUnread = notification.readStatus === SOURCES.NOTIFICATION_UNREAD;

    return (
        <div className="p-4 bg-gray-50 h-full">
            <Card className="shadow-sm">
                <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center gap-3">
                        <div className="bg-blue-50 size-12 flex justify-center items-center rounded-full text-primary">
                            <FontAwesomeIcon icon={faBell} size="lg" />
                        </div>
                        <div>
                            <h3 className="text-lg font-semibold m-0 text-gray-800">Notification Details</h3>
                        </div>
                    </div>
                    <div>
                        {isUnread ? (
                            <Button
                                icon={<FontAwesomeIcon icon={faCheck} />}
                                onClick={() => onMarkAsRead(notification)}
                                className='!text-primary !border-primary hover:!border-primary hover:!bg-primary hover:!text-white'
                            >
                                Mark as Read
                            </Button>
                        ) : (
                            <Tag color="success" className="px-3 py-1 text-sm">
                                Status: <span className='capitalize'>{notification.readStatus}</span>
                            </Tag>
                        )}
                    </div>
                </div>

                <Divider />

                <div className="mb-6">
                    <h4 className="text-sm font-semibold text-gray-600 uppercase tracking-wide mb-3">Message</h4>
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
                        <p className="text-gray-800 text-base leading-relaxed whitespace-pre-wrap mb-0">
                            {notification.notifyText}
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div className="bg-white p-3 rounded border border-gray-100">
                        <span className="text-xs text-gray-500 block mb-1">Date Time</span>
                        <div className="flex items-center gap-2 text-gray-700 font-medium">
                            <FontAwesomeIcon icon={faCalendarAlt} className="text-gray-400" />
                            {formatDateTime(notification.createdAt)}
                        </div>
                    </div>
                    <div className="bg-white p-3 rounded border border-gray-100">
                        <span className="text-xs text-gray-500 block mb-1">Relative Time</span>
                        <div className="flex items-center gap-2 text-gray-700 font-medium">
                            <FontAwesomeIcon icon={faClock} className="text-gray-400" />
                            {formatDateTimeFromNow(notification.createdAt)}
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default EnhancedNotificationDetails;
